import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { IoChevronBack } from 'react-icons/io5';
import Spinner from '../../components/common/Spinner';

const BannerDetailPage = () => {
  const { bannerId } = useParams();
  const navigate = useNavigate();
  const [banner, setBanner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const snap = await getDoc(doc(db, 'banners', bannerId));
        if (snap.exists()) {
          setBanner({ id: snap.id, ...snap.data() });
        }
      } catch (err) {
        console.error('배너 상세 로드 실패:', err);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [bannerId]);

  if (loading) return <Container><Loading><Spinner variant="dots" size="lg" text="로딩 중..." /></Loading></Container>;
  if (!banner) return <Container><Loading>배너를 찾을 수 없습니다</Loading></Container>;

  return (
    <Container>
      <Header>
        <BackBtn onClick={() => navigate(-1)}><IoChevronBack size={24} /></BackBtn>
        <HeaderTitle>상세보기</HeaderTitle>
        <Spacer />
      </Header>

      {banner.image && (
        <ImageArea>
          <BannerImage src={banner.image} alt={banner.title} />
        </ImageArea>
      )}

      <Content>
        <Title>{banner.title}</Title>
        {banner.description && <Description>{banner.description}</Description>}
      </Content>
    </Container>
  );
};

export default BannerDetailPage;

const Container = styled.div`
  min-height: 100vh;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #F0F0EC;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
`;

const BackBtn = styled.button`
  display: flex;
  align-items: center;
  color: #1E2A32;
  padding: 4px;
`;

const HeaderTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #1E2A32;
`;

const Spacer = styled.div`width: 32px;`;

const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #8C9AA4;
  font-size: 14px;
`;

const ImageArea = styled.div`
  width: 100%;
  aspect-ratio: 350 / 500;
  max-height: 500px;
  background: #F0F0EC;
  overflow: hidden;
`;

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Content = styled.div`
  padding: 24px 20px 40px;
`;

const Title = styled.h1`
  font-size: 22px;
  font-weight: 800;
  color: #1E2A32;
  line-height: 1.4;
`;

const Description = styled.p`
  font-size: 15px;
  color: #5A6B75;
  line-height: 1.7;
  margin-top: 16px;
  white-space: pre-wrap;
`;
